'use client'
import Navigation from '@/components/Navigation'

export default function Header() {
    return (
        <Navigation></Navigation>
    )
}